export function isUserResponse(maybeSession) {
    var _a, _b, _c;
    const postUrls = ['/email/verification', '/phone/verification', '/phone/verification/complete'];
    const getUrls = ['/user'];
    const patchUrls = ['/user'];
    const method = (_b = (_a = maybeSession.config) === null || _a === void 0 ? void 0 : _a.method) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    const url = (_c = maybeSession.config) === null || _c === void 0 ? void 0 : _c.url;
    return (!!url &&
        maybeSession.status === 200 &&
        ((postUrls.includes(url) && method === 'post') ||
            (getUrls.includes(url) && method === 'get') ||
            (patchUrls.includes(url) && method === 'patch')));
}
export function isUserSettingsResponse(maybeSession) {
    var _a, _b, _c;
    const method = (_b = (_a = maybeSession.config) === null || _a === void 0 ? void 0 : _a.method) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    const url = (_c = maybeSession.config) === null || _c === void 0 ? void 0 : _c.url;
    return !!url && maybeSession.status === 200 && '/user/settings' === url && method === 'patch';
}
